import kebabCase from 'lodash.kebabcase';
/**
 * Generates the path for a component's documentation page.
 */
export function buildComponentDocsPath(componentName, sectionId) {
    return buildStringFromSegments(["components-".concat(kebabCase(componentName)), sectionId], '#');
}
/**
 * Concatenates string segments after filtering out falsy values.
 */
export function buildStringFromSegments(segments, separator) {
    if (separator === void 0) { separator = ' '; }
    return segments.filter(function (segment) { return segment; }).join(separator);
}
/**
 * Returns `true` if the given value is `null` or `undefined`.
 * Useful for detecting `null`/`undefined` without false positives from falsy values like `0` and `''`.
 */
export function isNil(value) {
    return value === null || value === undefined;
}
export function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
/**
 * Calls the remainder operator (`%`) but makes sure that non-integer numbers are handled correctly
 * (see https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript).
 */
export function safeRemainder(dividend, divisor) {
    // Let the native remainder operator
    // (see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder#description)
    // handle tricky cases like infinity.
    if (dividend === Number.POSITIVE_INFINITY ||
        dividend === Number.NEGATIVE_INFINITY ||
        divisor === Number.POSITIVE_INFINITY ||
        divisor === Number.NEGATIVE_INFINITY) {
        return dividend % divisor;
    }
    // Adapted from https://stackoverflow.com/a/31711034.
    var dividendDecimalLength = (String(dividend).split('.')[1] || '').length;
    var divisorDecimalLength = (String(divisor).split('.')[1] || '').length;
    var decimalLength = dividendDecimalLength > divisorDecimalLength ? dividendDecimalLength : divisorDecimalLength;
    var dividendInt = parseInt(dividend.toFixed(decimalLength).replace('.', ''), 10);
    var divisorInt = parseInt(divisor.toFixed(decimalLength).replace('.', ''), 10);
    return (dividendInt % divisorInt) / Math.pow(10, decimalLength);
}
/**
 * Calls `parseInt()` with a default radix of `10` and falls back to `0` if `parseInt()` returns `NaN`.
 */
export function safeParseInt(str, radix) {
    if (radix === void 0) { radix = 10; }
    return parseInt(str, radix) || 0;
}
//# sourceMappingURL=primitiveHelpers.js.map